import OptionField from '@fd/frontend/components/ProxyPoolCreatePage/OptionFieldCard';
import Flex from '@fd/frontend/components/ui/Flex';
import useProxyPoolCreationForm from '@fd/frontend/store/proxyPoolCreationFormStore';
import clsx from 'clsx';

const PROXY_QUANTITIES = [1, 5, 10, 30, 50, 100];

export default function CreateProxiesCard() {
  const { quantity, setQuantity } = useProxyPoolCreationForm();

  return (
    <OptionField.Card>
      <OptionField.Body>
        <OptionField.Title>Proxies quantity</OptionField.Title>
        <OptionField.Description>
          To set the count of available proxies in the pool.
        </OptionField.Description>
      </OptionField.Body>
      <Flex.Row gap="4" className="flex-wrap">
        {PROXY_QUANTITIES.map((q) => (
          <ProxyQuantityButton
            key={q}
            quantity={q}
            isSelected={quantity === q}
            onClick={() => setQuantity(q)}
          />
        ))}
      </Flex.Row>
    </OptionField.Card>
  );
}

function ProxyQuantityButton({
  quantity,
  isSelected,
  onClick,
}: {
  quantity: number;
  isSelected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      className={clsx(
        'px-5 h-7 rounded-sm bg-primary-background text-sm text-secondary border hover:border-primary-purple border-border',
        isSelected && 'border-border-focus ring-1 ring-ring-focus',
      )}
      onClick={onClick}
    >
      {quantity}
    </button>
  );
}
